<div
  ngbDropdown
  #dropdown="ngbDropdown"
  [placement]="placement()"
  [autoClose]="'outside'"
  (openChange)="OnSuggesterOpenChange($event)"
>
  <div
    #anchor
    ngbDropdownAnchor
    [ngClass]="suggesterIconTemplate() ? 'input-group-side-icons' : 'input-group-right-icon'"
    class="position-relative pe-0"
  >
    <input
      #inputElement
      type="text"
      class="form-control"
      [placeholder]="placeholder()"
      data-automation-id="custom-suggester-input"
      [formControl]="inputValue()"
      (focus)="onFocus()"
      (keyup.enter)="onEnter()"
      (select)="$event.stopPropagation()"
      [focusableItemsContainer]="dropdownMenu"
      autocomplete="new-password"
      fDropdownListFocus
    />
    @if (suggesterIconTemplate()){
    <ng-template [ngTemplateOutlet]="suggesterIconTemplate() ?? null"></ng-template>
    }
    <i
      tabindex="0"
      class="f-i f-i-close"
      [class.invisible]="!inputValue().value?.length || loading()"
      data-automation-id="clear-value"
      (click)="clear()"
    ></i>
    @if (loading()) {
    <f-spinner [spinnerSize]="spinnerSizes.Sm" class="position-absolute translate-middle-y top-50 end-0 me-2" />
    }
    <div #dropdownMenu ngbDropdownMenu [fDropdownWidth]="anchor" [dropdown]="dropdown">
      @if (suggesterCustomTemplate()) {
      <ng-template [ngTemplateOutlet]="suggesterCustomTemplate() ?? null"></ng-template>
      }
    </div>
  </div>
</div>
